import React, { Component } from "react";
import { Switch, Redirect } from "react-router";
import { AuthenticatedRoute, UnauthenticatedRoute } from "components/Route";

/**
 * Import pages and routes
 */

import Home from "./Home/Home";
import Login from "./Login/Login";
import Register from "./Register/Register";
import Profile from "./Profile/Profile";
import Timer from "./Timer/Timer";
import Tips from "./Tips/Tips";
import Settings from "./Settings/Settings";
import Onboarding from "./Onboarding/Onboarding";
import PasswordForgot from "./Auth/PasswordForgot/PasswordForgot";
import PasswordReset from "./Auth/PasswordReset/PasswordReset";

class Routes extends Component {
    render() {
        return (
            <Switch>
                <Redirect exact from="/" to="/agenda" />
                <AuthenticatedRoute
                    exact
                    path="/agenda/:centerDay?"
                    component={Home}
                />
                <UnauthenticatedRoute
                    path="/inloggen/:token?"
                    component={Login}
                />
                <UnauthenticatedRoute
                    path="/activeer/:page?"
                    component={Register}
                />
                <UnauthenticatedRoute
                    path="/wachtwoord/vergeten"
                    component={PasswordForgot}
                />
                <UnauthenticatedRoute
                    path="/wachtwoord/herstellen"
                    component={PasswordReset}
                />
                <AuthenticatedRoute path="/onboarding" component={Onboarding} />
                <AuthenticatedRoute path="/profile" component={Profile} />
                <AuthenticatedRoute
                    path="/timer/:date/:taskId?"
                    component={Timer}
                />
                <AuthenticatedRoute path="/tips" component={Tips} />
                <AuthenticatedRoute path="/settings" component={Settings} />
            </Switch>
        );
    }
}

export default Routes;
